package fi.bullpen.kmpapp.data.turnkey.dto

import kotlinx.serialization.Serializable

@Serializable
data class RecoverUserIntent(val authenticator: AuthenticatorParamsV2, val userId: String) : Intent
